import Node from '../node.js';
import Utils from '../utils.js';
import { PARAM_TYPE } from '../connector.js';

export default class NodeMerge extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}
	
	getType()
	{
		return 'merge';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pRes = [];
		let pInputs = this.getInputs();
		for(let pInput of pInputs)
		{
			if(!pInput.getConnectedNode())
				continue;

			const strName = pInput.getName();
			if(Array.isArray(inputValues[strName]))
				pRes = pRes.concat(inputValues[strName]);
			else if(inputValues[strName] !== null)
				pRes.push(inputValues[strName]);
		}

		pRes = pRes.filter(obj => !!obj);
		for(let obj of pRes)
		{
			const duplicateMeshes = pRes.filter(currObj => currObj.uniqueId === obj.uniqueId);
			if(duplicateMeshes.length > 1)
				throw new Error(`Outputting duplicate meshes: ${duplicateMeshes[0].name}`);
		}

		let invalidMeshNames = Utils.haveInvalidMeshes(pRes);
		if(invalidMeshNames) {
			throw new Error(`Outputting a mesh that is already disposed from the node ${this.getLabel()} meshes: ${invalidMeshNames.join(' ')}`);
		}

		return pRes;
	}
}
